import { connect } from "react-redux";
import TinySettlementCenter from "../views/tiny/TinySettlementCenter";

function mapStateToProps() {
  return {};
}

const mapDispatchToProps = () => ({});

const TinySettlementCenterContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TinySettlementCenter);

export default TinySettlementCenterContainer;

